import { HistoryUrl } from '@tmf-shared-platform/history-url/history-url';

export class HistoryUrlAdapter {
  constructor(private _historyUrl: HistoryUrl) {}

  public routerMightUpdated(): void {
    window.dispatchEvent(new Event('routerUpdated'));
  }

  public routerMightReplaced(): void {
    window.dispatchEvent(new Event('routerReplaced'));
  }

  public routerMightWentBack(n: number): void {
    window.dispatchEvent(new CustomEvent('routerGoingBack', { detail: { count: n } }));
  }

  public get history(): string[] {
    return this._historyUrl.history;
  }
}
